import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import FilterListIcon from "@material-ui/icons/FilterList";
import PrintIcon from "@material-ui/icons/Print";
import CommonButton from "app/common/Component/Button/CommonButton";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import HandleKeydown from "app/common/HandleKeydown";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconMedicalHistory from "app/common/Icon/EyeTestTabs/IconMedicalHistory";
import IconDelete from "app/common/Icon/IconDelete";
import IconEye from "app/common/Icon/IconEye";
import IconPen from "app/common/Icon/IconPen";
import {
  LAVoucherItemRevenueType,
  TYPE_CARD,
  VOUCHER_INVOICE_TYPE,
  VOUCHER_STATUS,
  VOUCHER_STATUS_VALUE,
} from "app/common/LocalConst";
import {
  checkPaymentMethodLimits,
  formatMoney,
  formatNumber,
  getDateTime,
  getDepartmentsUser,
  IconDescription,
  isAdmin,
  isRoleBranchManager,
  isRoleCashier,
  isRoleHisAccountant,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import { pagingDepartment } from "app/services/DepartmentService";
import { onOffLimitPage } from "app/services/VoucherService";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CancelInvoicePopup from "../../Popup/CancelInvoicePopup";
import DepositFeePopup from "../../Popup/DepositFeePopup";
import HistoryFeePopup from "../../Popup/HistoryFeePopup";
import PaymentVoucherPopup from "../../Popup/PaymentVoucherPopup";
import PrintPopup from "../../Popup/PrintPopup";
import PrintPopupApi from "../../Popup/PrintPopupApi";
import RefundDepositPopup from "../../Popup/RefundDepositPopup";
import VoucherPopupDetail from "../../Popup/VoucherPopupDetail";
import VoucherTemporaryPopup from "../../Popup/VoucherTemporaryPopup";

const ServiceFeeTabIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  let [isOpenFillter, setOpenFillter] = useState(true);

  const {
    resetStore,
    dataVoucherFee,
    handleOpenServiceFeePopup,
    handleCloseServiceFeePopup,
    getListPaymentMethod,
    openPopupPrint,
    handleChangeFormSearch,
    searchVoucherFee,
    getDataDetailVoucher,
    openVoucherPopupDetail,
    dataVoucherPopupFee,
    handleOpenServiceUpdate,
    editableVoucher,
    handleOpenDepositPopup,
    listStk,
    listPos,
    listHomecredit,
    listPos_tragop,
    handleUpdateVoucher,
    handleCloseDepositPopup,
    openDepositPopup,
    initialDeposit,
    handleReceiveAdvancePayment,
    selectedFee,
    handleClosePrintPopup,
    handleOpenPaymentVoucherPopup,
    openPaymentVoucherPopup,
    initialPaymentVoucher,
    createPaymentVoucherWithListMethod,
    handleClosePaymentVoucherPopup,
    listPaymentMethod,
    handleUpdateTemporaryVoucher,
    dataVoucherTemporaryPopup,
    openVoucherTempoaryPopup,
    handleCloseVoucherTemporaryPopup,
    getDataTemporaryVoucher,
    handleOpenPopupPrintApi,
    openPopupPrintApi,
    handleClosePrintPopupApi,
    listDataPrinApi,
    handleOpenConfirmDeleteReason,
    openConfirmDeleteReason,
    handleDeleteVoucherWithReason,
    rowDataVoucher,
    handleOpenHistoryFeePopup,
    openHistoryFeePopup,
    handleCloseHistoryFeePopup,
    searchDataHistory,
    pageDataHistory,
    handleChangeFormSearchHistory,
    handleOpenRefundDepositPopup,
    handleCloseRefundDepositPopup,
    handleRefundDeposit,
    openRefundDepositPopup,
    initialRefundDeposit,
  } = useStore().feeStore.serviceFeeTabStore;
  const {
    initialPatient,
    customerSourceWalkIn,
    handleGetPatientOverviewByIdNotLoading,
  } = useStore().patientManagementStore.patientGeneralStore;
  const defaultDepartment = useDefaultDepartment();
  const departmentsUser = getDepartmentsUser();
  let isAdminPermission = isAdmin();
  useEffect(() => {
    if (patientId) {
      let departmentIds = [];
      if (isAdminPermission) {
        departmentIds = defaultDepartment ? [defaultDepartment.id] : [];
      } else {
        departmentIds = departmentsUser?.length
          ? departmentsUser.map((d) => d.id)
          : defaultDepartment
          ? [defaultDepartment.id]
          : [];
      }
      handleChangeFormSearch({
        patientId,
        fromDate: null,
        toDate: null,
        departmentIds,
      });
    }
  }, []);

  let isRoleCashierPermission = isRoleCashier();
  let isRoleBranchManagerPermission = isRoleBranchManager();
  let isRoleHisAccountants = isRoleHisAccountant();
  const isReadonly = isRoleHisReadOnly();
  const [toggling, setToggling] = useState({});
  const handleToggleLimitPage = async (voucher) => {
    try {
      setToggling((prev) => ({ ...prev, [voucher.id]: true }));
      const newStatus = !voucher.showOnLimitPage;
      const payload = {
        voucherIds: [voucher.id],
        showOnLimitPage: newStatus,
      };
      await onOffLimitPage(payload);
      voucher.showOnLimitPage = newStatus;
      toast.success(
        newStatus
          ? "Đã bật hiển thị trên trang limit"
          : "Đã tắt hiển thị trên trang limit"
      );
    } catch (error) {
      console.error(error);
      toast.error("Lỗi khi cập nhật trạng thái hiển thị");
    } finally {
      setToggling((prev) => ({ ...prev, [voucher.id]: false }));
    }
  };
  return (
    <section className="mx-2 ">
      <Formik
        initialValues={searchVoucherFee}
        onSubmit={(values) => {
          handleChangeFormSearch({ ...values, patientId, pageIndex: 1 });
        }}
        enableReinitialize
      >
        <Form autoComplete="off">
          <Grid container component={"section"} spacing={1}>
            <Grid item xs={6} md={3}>
              <div className="w-50">
                <p
                  className="cards-header flex align-center item-form-header-custom gap-1"
                  style={{ fontSize: "16px" }}
                >
                  <span
                    className="flex items-center pointer"
                    style={{ fontWeight: "bold" }}
                  >
                    Danh sách phiếu
                  </span>
                  <span
                    style={{ cursor: "pointer" }}
                    className="flex items-center"
                    onClick={() => setOpenFillter(!isOpenFillter)}
                  >
                    <FilterListIcon color="red" />
                  </span>
                </p>
              </div>
            </Grid>
            <Grid item xs={6} md={9} className="flex align-center justify-end">
              {!isMobile && (
                <div className="flex-end gap-3">
                  {(isAdminPermission ||
                    isRoleCashierPermission ||
                    isRoleBranchManagerPermission) && (
                    <>
                      <HandleKeydown
                        title={`Thu tiền (F1)`}
                        handlePush={() => {
                          handleOpenServiceFeePopup({
                            patient: initialPatient?.patientInfo,
                          });
                        }}
                      />
                      <Tooltip title="Cọc tiền">
                        <CommonButton
                          onClick={() => {
                            handleOpenDepositPopup(
                              initialPatient?.patientInfo,
                              customerSourceWalkIn,
                              defaultDepartment
                            );
                          }}
                        >
                          Thu tiền cọc
                        </CommonButton>
                      </Tooltip>
                      <Tooltip title="Phiếu chi">
                        <CommonButton
                          onClick={() => {
                            handleOpenPaymentVoucherPopup(
                              initialPatient?.patientInfo,
                              null,
                              customerSourceWalkIn
                            );
                          }}
                        >
                          Phiếu chi
                        </CommonButton>
                      </Tooltip>
                      <Tooltip title="Hoàn tiền cọc">
                        <CommonButton
                          onClick={() => {
                            handleOpenRefundDepositPopup(
                              initialPatient?.patientInfo
                            );
                          }}
                        >
                          Hoàn tiền cọc
                        </CommonButton>
                      </Tooltip>
                    </>
                  )}
                  {/* <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <CommonButton
                      onClick={() => handleOpenPopupPrint(true)}
                      style={{ position: "relative" }}
                    >
                      In phiếu
                    </CommonButton>
                  </div> */}
                </div>
              )}
              {isMobile && (
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  <CommonButton
                    onClick={async (e) =>
                      setAnchorEl(anchorEl ? null : e.target)
                    }
                    style={{ position: "relative" }}
                  >
                    Thao tác
                  </CommonButton>
                  {anchorEl && (
                    <div
                      className="popover-list"
                      style={{
                        right: 0,
                        left: "auto",
                        position: "absolute",
                      }}
                    >
                      {(isAdminPermission ||
                        isRoleCashierPermission ||
                        isRoleBranchManagerPermission) && (
                        <>
                          <div
                            className="popover-item"
                            style={{ color: "#4276a4" }}
                            onClick={() => {
                              handleOpenServiceFeePopup({
                                patient: initialPatient?.patientInfo,
                              });
                              setAnchorEl(null);
                            }}
                          >
                            Thu tiền (F1)
                          </div>
                          <div
                            className="popover-item"
                            style={{ color: "#4276a4" }}
                            onClick={() => {
                              handleOpenDepositPopup(
                                initialPatient?.patientInfo,
                                customerSourceWalkIn,
                                defaultDepartment
                              );
                              setAnchorEl(null);
                            }}
                          >
                            Thu tiền cọc
                          </div>
                          <div
                            className="popover-item"
                            style={{ color: "#4276a4" }}
                            onClick={() => {
                              handleOpenPaymentVoucherPopup(
                                initialPatient?.patientInfo,
                                null,
                                customerSourceWalkIn
                              );
                              setAnchorEl(null);
                            }}
                          >
                            Phiếu chi
                          </div>
                          <div
                            className="popover-item"
                            style={{ color: "#4276a4" }}
                            onClick={() => {
                              handleOpenRefundDepositPopup(
                                initialPatient?.patientInfo
                              );
                              setAnchorEl(null);
                            }}
                          >
                            Hoàn tiền cọc
                          </div>
                        </>
                      )}
                      {/* <div
                        className="popover-item"
                        style={{ color: "#4276a4" }}
                        onClick={() => {
                          handleOpenPopupPrint(true);
                          setAnchorEl(null);
                        }}
                      >
                        In phiếu
                      </div> */}
                    </div>
                  )}
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={12}>
              {!isOpenFillter && (
                <>
                  <style>
                    {`
                      @keyframes slideDownFade {
                        0% {
                          opacity: 0;
                          transform: translateY(-10px);
                        }
                        100% {
                          opacity: 1;
                          transform: translateY(0);
                        }
                      }
                    `}
                  </style>
                  <div
                    style={{
                      animation: "slideDownFade 0.3s ease forwards",
                      zIndex: 10,
                      position: "relative",
                    }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={2}>
                        <GlobitsMultiDatePicker
                          label="Từ ngày - đến ngày"
                          name="fromDate"
                          range
                          rangeHover
                          fromField="fromDate"
                          toField="toDate"
                          // format={"DD/MM/YYYY"}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <GlobitsPagingAutocomplete
                          api={pagingDepartment}
                          label="Cơ sở"
                          name="departmentId"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={"auto"}
                        className="flex flex-end gap-2"
                      >
                        <Button className="btn-primary" type="submit">
                          <Search />
                          Tìm kiếm
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </>
              )}
            </Grid>
            <Grid item xs={12} className="flex-center">
              <IconDescription list={VOUCHER_STATUS} />
            </Grid>

            <Grid
              item
              xs={12}
              className="justify-center cards-body pt-0 mt-2"
              style={{
                zIndex: 1,
                position: "relative",
              }}
            >
              <TableComponent
                className=""
                showOrdinalNumbers
                titleNodata={t("noData")}
                data={dataVoucherFee?.content}
                name="ServiceFeeTab"
                showMoreButton
                rowCss={(row) =>
                  VOUCHER_STATUS.find((el) => el?.value === row?.status)
                    ?.className
                }
                columns={[
                  {
                    title: t("action"),
                    field: "action",
                    align: "center",
                    render: (voucher) => (
                      <div className="flex-center gap-2">
                        {!isReadonly && (
                          <Tooltip title={"Xem lịch sử thanh toán"}>
                            <span
                              className={"flex align-center"}
                              onClick={() =>
                                handleOpenHistoryFeePopup({
                                  patient: initialPatient?.patientInfo,
                                  id: voucher?.id,
                                })
                              }
                              style={{ width: "18px" }}
                            >
                              <IconMedicalHistory color="blue" />
                            </span>
                          </Tooltip>
                        )}
                        <Tooltip title="xem chi tiết">
                          <div
                            className="flex"
                            onClick={() =>
                              getDataDetailVoucher(voucher, defaultDepartment)
                            }
                          >
                            <IconEye />
                          </div>
                        </Tooltip>
                        {!isReadonly && (
                          <>
                            {VOUCHER_STATUS_VALUE.New === voucher?.status && (
                              <Tooltip title="Cập nhật phiếu tạm">
                                <div
                                  className="flex"
                                  onClick={() =>
                                    getDataTemporaryVoucher(voucher)
                                  }
                                >
                                  <ControlPointIcon />
                                </div>
                              </Tooltip>
                            )}
                          </>
                        )}
                        {!isReadonly && (
                          <>
                            {!(
                              voucher?.status === VOUCHER_STATUS_VALUE.Cancel
                            ) && (
                              <>
                                {(isAdminPermission ||
                                  isRoleCashierPermission ||
                                  isRoleBranchManagerPermission) &&
                                  VOUCHER_STATUS_VALUE.New !==
                                    voucher?.status && (
                                    <Tooltip title="Chỉnh sửa">
                                      <div
                                        className="flex"
                                        onClick={() => {
                                          handleOpenServiceUpdate(
                                            {
                                              ...voucher,
                                              patientId,
                                            },
                                            defaultDepartment
                                          );
                                        }}
                                      >
                                        <IconPen />
                                      </div>
                                    </Tooltip>
                                  )}
                                {(isAdminPermission ||
                                  isRoleCashierPermission ||
                                  isRoleHisAccountants) && (
                                  <Tooltip title="Xóa">
                                    <div
                                      className="flex"
                                      onClick={() => {
                                        handleOpenConfirmDeleteReason(
                                          voucher?.id
                                        );
                                        //  else {
                                        //   handleOpenConfirmDelete(voucher?.id);
                                        // }
                                      }}
                                    >
                                      <IconDelete />
                                    </div>
                                  </Tooltip>
                                )}
                                {/* <Tooltip
                                 title="In phiếu"
                                 onClick={() => {
                                   handleOpenPopupPrint(true);
                                   handleFeePopupPrint(voucher);
                                 }}
                               >
                                 <div className="flex">
                                   <PrintIcon />
                                 </div>
                               </Tooltip> */}

                                {/* nút in này call api */}
                                <Tooltip
                                  title="In phiếu"
                                  onClick={() =>
                                    handleOpenPopupPrintApi(voucher)
                                  }
                                >
                                  <div className="flex">
                                    <PrintIcon />
                                  </div>
                                </Tooltip>
                              </>
                            )}
                          </>
                        )}
                        {isAdminPermission && (
                          <Tooltip
                            title={
                              voucher.showOnLimitPage
                                ? "Tắt hiển thị trang limit"
                                : "Bật hiển thị trang limit"
                            }
                          >
                            <div
                              className={`flex toggle-wrapper ${
                                toggling[voucher.id] ? "disabled" : ""
                              }`}
                              onClick={() =>
                                !toggling[voucher.id] &&
                                handleToggleLimitPage(voucher)
                              }
                            >
                              <div
                                className={`toggle-switch ${
                                  voucher.showOnLimitPage ? "on" : "off"
                                }`}
                              >
                                <div className="toggle-circle" />
                              </div>
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    ),
                  },
                  {
                    field: "code",
                    title: "Mã phiếu",
                    render: (row) => (
                      <>
                        <b style={{ color: "green" }}>{row?.code}</b>
                        {row?.status === VOUCHER_STATUS_VALUE.Cancel && (
                          <p style={{ color: "RED" }}>
                            <b>ĐÃ HỦY</b>
                          </p>
                        )}
                      </>
                    ),
                  },

                  {
                    field: "code",
                    title: "Loại",
                    render: (row) =>
                      VOUCHER_INVOICE_TYPE?.find(
                        (el) => el?.value === row?.voucherInvoiceType
                      )?.name || "",
                  },
                  {
                    field: "eInvoiceIssuedDate",
                    title: t("Trạng thái"),
                    render: (row) =>
                      VOUCHER_STATUS?.find((el) => el?.value === row?.status)
                        ?.name || "",
                  },
                  {
                    field: "quantity",
                    title: t("Ngày tạo"),
                    render: (row) => getDateTime(row?.voucherDate),
                  },

                  {
                    field: "note",
                    title: t("Tổng tiền"),
                    align: "right",
                    render: (row) => (
                      <b>{formatMoney(row?.moneyAfterDiscount)}</b>
                    ),
                  },

                  {
                    field: "note",
                    title: t("CTKM áp dụng"),
                    align: "right",
                    render: (row) => (
                      <>
                        {row?.promotionProgramCode && (
                          <div>
                            <div>Mã CTKM: {row?.promotionProgramCode}</div>
                            <div>
                              {" "}
                              - Giảm :{formatMoney(row?.allocateDiscount)}
                            </div>
                          </div>
                        )}
                      </>
                    ),
                  },

                  {
                    field: "department.name",
                    title: t("Cơ sở"),
                  },
                  {
                    field: "note",
                    title: t("Chi tiết"),
                    render: (row) => {
                      const items = row?.items || [];
                      let htmls = items.map((it, index) => {
                        const {
                          treatmentPlanCard,
                          patientServiceRegister,
                          drugOrder,
                        } = it;
                        const registeredName =
                          treatmentPlanCard?.clientCard?.registeredName?.trim() ||
                          patientServiceRegister?.service?.registeredName?.trim() ||
                          drugOrder?.drug?.registeredName?.trim();
                        return (
                          <div class="detail-item">
                            <div className="flex flex-col gap-2 align-start">
                              <Tooltip title="Số tiền thanh toán trong hóa đơn">
                                <span style={{ fontWeight: "bold" }}>
                                  <span className="plus">
                                    {row.voucherType === -1 ? "-" : "+"}
                                  </span>
                                  {formatMoney(
                                    it?.amount - it?.allocateDiscount
                                  )}
                                </span>
                              </Tooltip>
                              <span
                                className="desc"
                                style={{ color: "sienna" }}
                              >
                                {checkPaymentMethodLimits()
                                  ? registeredName || it?.content
                                  : it?.content}
                              </span>

                              <p
                                style={{
                                  fontStyle: "normal",
                                  color: "red",
                                }}
                                className="ml-1"
                              >
                                {" "}
                                {it?.treatmentPlanCard?.code ||
                                  it?.patientServiceRegister?.code ||
                                  it?.drugOrder?.code ||
                                  ""}
                              </p>
                            </div>
                            {it?.staffRevenues?.length > 0 && (
                              <div className="staff-list">
                                {it.staffRevenues.map((el, ind) => (
                                  <div className="staff-item" key={ind}>
                                    👤{" "}
                                    <span className="revenue-percent">
                                      {el?.source?.name} -{" "}
                                    </span>
                                    <span className="staff-name">
                                      {el?.staff?.staffName}
                                    </span>
                                    <span className="percent">
                                      – {formatNumber(el?.percentRevenue)}%
                                    </span>
                                    <span className="plus">
                                      – {formatMoney(el?.actualAmount)}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                            {it?.treatmentPlanCard && (
                              <>
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "blue",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <i>
                                    <span
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {TYPE_CARD.find(
                                        (el) =>
                                          el.value ===
                                          it?.treatmentPlanCard?.clientCard
                                            ?.typeCard
                                      )?.name || ""}
                                    </span>
                                    :{" "}
                                    {it?.treatmentPlanCard?.clientCard?.name ||
                                      ""}
                                  </i>
                                </div>
                              </>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: "1px dashed #ccc",
                              }}
                            >
                              {it?.invoiceItem?.subAmountActuallyPaid > 0 && (
                                <div
                                  style={{
                                    fontSize: "11px",
                                  }}
                                >
                                  <i>
                                    <span>
                                      <Tooltip title="Đã thu/chi">
                                        <b style={{ color: "green" }}>
                                          {formatMoney(
                                            it?.invoiceItem
                                              ?.subTotalBillPatientPaid || 0
                                          )}
                                        </b>
                                      </Tooltip>
                                    </span>
                                    /
                                    <span>
                                      <Tooltip title="Cần thu">
                                        <b style={{ color: "red" }}>
                                          {formatMoney(
                                            it?.invoiceItem
                                              ?.subAmountActuallyPaid
                                          )}
                                        </b>
                                      </Tooltip>
                                    </span>
                                  </i>
                                </div>
                              )}
                              <span style={{ fontSize: "12px", color: "#666" }}>
                                <b style={{ marginLeft: 4 }}>
                                  {LAVoucherItemRevenueType?.[
                                    it.voucherItemRevenueType
                                  ]?.name ||
                                    Object.values(
                                      LAVoucherItemRevenueType
                                    ).find(
                                      (v) =>
                                        v.value === it.voucherItemRevenueType
                                    )?.name ||
                                    "Không rõ"}
                                </b>
                              </span>
                            </div>
                          </div>
                        );
                      });
                      return htmls;
                    },
                  },

                  {
                    width: 250,
                    title: t("HTTT"),
                    render: (row) => {
                      const methods = row.voucherPaymentMethods || [];

                      return (
                        <div>
                          {methods.map((method, index) => {
                            const name = method?.paymentMethodValue?.name || "";
                            const amount = method?.totalOfMethod ?? 0;
                            const bankAccountNumber =
                              method?.bankAccountNumber || "";
                            const bankName = method?.bankName || "";
                            return (
                              <>
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <span>
                                    {name && `${name}: `}
                                    <b style={{ color: "green" }}>
                                      {formatMoney(amount)}
                                    </b>
                                  </span>
                                  {bankName && (
                                    <div>
                                      <span>
                                        <b>{bankName} </b>
                                        {bankAccountNumber && (
                                          <i
                                            style={{
                                              fontSize: "11px",
                                              color: "red",
                                              fontWeight: "500",
                                            }}
                                          >
                                            - {bankAccountNumber}
                                          </i>
                                        )}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </>
                            );
                          })}
                        </div>
                      );
                    },
                  },
                  {
                    field: "createdBy",
                    title: t("Người tạo"),
                  },
                  {
                    field: "note",
                    title: t("Nội dung"),
                  },

                  {
                    field: "accountant.staffName",
                    title: t("Thu ngân"),
                  },
                  {
                    field: "drugOrder.productName",
                    title: t("Dịch vụ / Sản phẩm chi"),
                    render: (row) =>
                      row?.drugOrder
                        ? row?.drugOrder.productName
                        : row?.patientServiceRegister?.service?.name,
                  },
                  {
                    field: "createDate",
                    title: t("Thời gian tạo (theo hệ thống)"),
                    render: (row) => getDateTime(row?.createDate),
                  },
                ].filter(Boolean)}
                dataPagination={{
                  pageIndex: searchVoucherFee?.pageIndex,
                  pageSize: searchVoucherFee?.pageSize,
                  totalElements: dataVoucherFee?.totalElements,
                  totalPages: dataVoucherFee?.totalPages,
                  setPageIndex: (pageIndex) =>
                    handleChangeFormSearch({ pageIndex }),
                  setPageSize: (pageSize) =>
                    handleChangeFormSearch({ pageSize }),
                }}
              />
            </Grid>
          </Grid>
        </Form>
      </Formik>

      {openPopupPrint && (
        <PrintPopup
          open={openPopupPrint}
          handleClose={handleClosePrintPopup}
          dataVoucherFee={selectedFee}
        />
      )}

      {openPopupPrintApi && (
        <PrintPopupApi
          open={openPopupPrintApi}
          handleClose={handleClosePrintPopupApi}
          dataVoucherFee={listDataPrinApi}
          rowDataVoucher={rowDataVoucher}
        />
      )}

      {openVoucherPopupDetail && (
        <VoucherPopupDetail
          open={openVoucherPopupDetail}
          handleClose={handleCloseServiceFeePopup}
          detailData={dataVoucherPopupFee}
          editable={editableVoucher}
          handleUpdateVoucher={handleUpdateVoucher}
          handleAfterSubmit={() =>
            handleGetPatientOverviewByIdNotLoading(patientId)
          }
          listStk={listStk}
          listPos={listPos}
          listHomecredit={listHomecredit}
          listPos_tragop={listPos_tragop}
          patientId={patientId}
        />
      )}

      {openVoucherTempoaryPopup && (
        <VoucherTemporaryPopup
          open={openVoucherTempoaryPopup}
          handleClose={handleCloseVoucherTemporaryPopup}
          detailData={dataVoucherTemporaryPopup}
          editable={editableVoucher}
          handleUpdateVoucher={handleUpdateTemporaryVoucher}
          listStk={listStk}
        />
      )}

      {openDepositPopup && (
        <DepositFeePopup
          open={openDepositPopup}
          handleClose={handleCloseDepositPopup}
          initialData={initialDeposit}
          handleSubmit={handleReceiveAdvancePayment}
          patient={initialPatient?.patientInfo}
          customerSourceWalkIn={customerSourceWalkIn}
        />
      )}

      {/* {openConfirmDelete && (
        <ConfirmPopup
          open={openConfirmDelete}
          onClose={() => handleOpenConfirmDelete(null)}
          text="Bạn có chắc chắn muốn hủy hóa đơn này không ?"
          onConfirm={async () => {
            const data = await handleDeleteVoucher();
            if (data?.responseStatus !== false) {
              handleGetPatientOverviewById(patientId);
            }
          }}
        />
      )} */}

      {
        <>
          <CancelInvoicePopup
            open={openConfirmDeleteReason}
            handleClose={() => handleOpenConfirmDeleteReason(null)}
            onConfirm={async (reason) => {
              const data = await handleDeleteVoucherWithReason(reason);
              await handleOpenConfirmDeleteReason(null);
              if (data?.responseStatus !== false) {
                await handleGetPatientOverviewByIdNotLoading(patientId);
              }
            }}
          />
        </>
      }

      {openPaymentVoucherPopup && (
        <PaymentVoucherPopup
          open={openPaymentVoucherPopup}
          handleClose={handleClosePaymentVoucherPopup}
          initialPaymentVoucher={initialPaymentVoucher}
          handleSubmit={createPaymentVoucherWithListMethod}
          patient={initialPatient?.patientInfo}
          listPaymentMethod={listPaymentMethod}
          listStk={listStk}
          listPos={listPos}
          listHomecredit={listHomecredit}
          listPos_tragop={listPos_tragop}
          isSingleVoucher={true}
        />
      )}
      {openHistoryFeePopup && (
        <HistoryFeePopup
          open={openHistoryFeePopup}
          handleClose={handleCloseHistoryFeePopup}
          searchData={searchDataHistory}
          pageDataHistory={pageDataHistory}
          handleChangeFormSearch={handleChangeFormSearchHistory}
        />
      )}
      <DialogErrorDelete />
      {openRefundDepositPopup && (
        <RefundDepositPopup
          open={openRefundDepositPopup}
          handleClose={handleCloseRefundDepositPopup}
          initialData={initialRefundDeposit}
          handleSubmit={handleRefundDeposit}
        />
      )}
    </section>
  );
};


const DialogErrorDelete = observer(() => {
  const { openConfirmError, setOpenConfirmError } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      {!!openConfirmError && (
        <GlobitsConfirmationDialog
          maxWidth={"xs"}
          title="Thông báo!"
          text={openConfirmError?.responseDetail}
          onConfirmDialogClose={() => {
            setOpenConfirmError(null);
          }}
          cancel="Đóng"
          open={!!openConfirmError}
        />
      )}
    </>
  );
});

export default memo(observer(ServiceFeeTabIndex));
